import { IoMdOpen } from "react-icons/io";
import { MdDeleteForever } from "react-icons/md";
import { fontstyle1, fontstyle2, fontstyle3 } from "../../utils/fonts";
import instance from "../../utils/axios";
import history from "../../utils/history";

const DashboardCard = (props) => {
  const DeleteProject = (data) => {
    const { pid } = data;
    instance
      .post("/deleteProject", {
        uid: localStorage.getItem("dofeedbackin_uid"),
        projectid: pid
      })
      .then((res) => {
        if (res.data.status === "error") {
          alert("Error: Server error");
        } else {
          history.go();
        }
      })
      .catch((err) => console.log(err));
  };

  const datemodify = () => {
    const date = new Date(props.date);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const datemodified = `${day}-${month}-${year}`;
    return datemodified;
  };

  return (
    <div className="h-48 w-48 bg-[#FD7E50] rounded-md flex flex-col items-start justify-between">
      <div className="w-full flex items-start justify-between p-3">
        <div
          className="h-14 w-14 bg-white text-[#FD7E50] rounded-full text-center flex items-center justify-center text-xl"
          style={fontstyle2}
        >
          {props.name.toString()[0].toUpperCase()}
        </div>

        <div className="flex gap-2">
          <div
            onClick={() => {
              DeleteProject({
                pid: props.pid
              });
            }}
            className="text-white text-2xl cursor-pointer"
          >
            <MdDeleteForever />
          </div>
          <a href={"/project/" + props.id + "&" + props.pid}>
            <div className="text-white text-2xl">
              <IoMdOpen />
            </div>
          </a>
        </div>
      </div>
      <div className="p-3 w-48">
        <div
          className="text-white pb-2 w-full overflow-clip text-ellipsis"
          style={fontstyle1}
        >
          {props.name}
        </div>
        <div className="text-white text-sm" style={fontstyle3}>
          {datemodify()}
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
